module.exports = __webpack_public_path__ + "img/6_fineTeam_ts.b51aa96f.png";